import { Icon } from './Icon';

type IconProps = {
  color?: string;
  size?: string;
};

export const CloseIcon: React.FC<IconProps> = ({ color, size }) => {
  return (
    <Icon color={color} size={size}>
      <path d="M13.2852 11.75L16.2383 8.82422C16.4023 8.66016 16.4023 8.35938 16.2383 8.19531L15.5547 7.51172C15.3906 7.34766 15.0898 7.34766 14.9258 7.51172L12 10.4648L9.04688 7.51172C8.88281 7.34766 8.58203 7.34766 8.41797 7.51172L7.73438 8.19531C7.57031 8.35938 7.57031 8.66016 7.73438 8.82422L10.6875 11.75L7.73438 14.7031C7.57031 14.8672 7.57031 15.168 7.73438 15.332L8.41797 16.0156C8.58203 16.1797 8.88281 16.1797 9.04688 16.0156L12 13.0625L14.9258 16.0156C15.0898 16.1797 15.3906 16.1797 15.5547 16.0156L16.2383 15.332C16.4023 15.168 16.4023 14.8672 16.2383 14.7031L13.2852 11.75Z" />
    </Icon>
  );
};
